import React from "react";
import { Drawer, Skeleton, Table } from "antd";
import Close from "../../../assets/images/close-x.svg";
import { tableComponents, getStockColumns } from "./productPanelColumns";

const ProductPanelTable = ({
  stockDrawerVisible,
  selectedStockProduct,
  stockLoading,
  stockList,
  selectedStockRow,
  setSelectedStockRow,
  requestQty,
  setRequestQty,
  transformedRows,
  currenciesList,
  handleStockTransferRequest,
  closeStockDrawer,
}) => {
  if (!stockDrawerVisible) return null;

  const columns = getStockColumns({ currenciesList, selectedStockRow, setSelectedStockRow });

  return (
    <Drawer
      styles={{ header: { background: "white", borderBottom: "none" }, body: { padding: "0.5rem", paddingTop: 0, background: "white" }, mask: { backgroundColor: "#000000a6" } }}
      style={{ borderRadius: "15px" }}
      title={
        <div style={{ fontSize: "1.2em", fontWeight: "600", color: "#0F0718", fontFamily: "Inter", textAlign: "center", paddingTop: "20px" }}>
          {selectedStockProduct?.name || "Product Name"}
          <img
            src={Close || "/placeholder.svg"}
            onClick={closeStockDrawer}
            style={{
              position: "absolute",
              top: "50%",
              right: "1rem",
              transform: "translateY(-50%)",
              cursor: "pointer",
              width: "24px",
              height: "24px",
            }}
            alt="Close"
          />
        </div>
      }
      placement="right"
      closable={false}
      onClose={closeStockDrawer}
      open={stockDrawerVisible}
      width="70vw"
    >
      {stockLoading ? (
        <Skeleton active paragraph={{ rows: 4 }} />
      ) : selectedStockProduct ? (
        <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "20px", position: "relative", height: "41vh", width: "100%", margin: "0 0% 1% 0%" }}>
          {stockList.length > 0 ? (
            <div>
              <div
                style={{
                  border: "1px solid #D1D5DB",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginBottom: "20px",
                }}
              >
                <Table
                  dataSource={transformedRows}
                  columns={columns}
                  pagination={false}
                  components={tableComponents}
                  size="small"
                  bordered={false}
                  scroll={{ y: 250 }}
                  rowClassName={(record) => (selectedStockRow?.key === record?.key ? "selected-row" : "")}
                  onRow={(record) => ({
                    onClick: () => {
                      if (record.isCurrentStore) return;
                      setSelectedStockRow(record);
                    },
                    style: record.isCurrentStore ? { cursor: "not-allowed", opacity: 0.5 } : { cursor: "pointer" },
                  })}
                  className="minimal-stock-table"
                />
              </div>
            </div>
          ) : (
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "20px",
                color: "#2F3856",
                fontFamily: "Inter",
              }}
            >
              <h3 style={{ margin: 0, fontSize: "1.2em", fontWeight: 600 }}>No Stock Available</h3>

              <p style={{ marginTop: "8px", fontSize: "0.9em", color: "#6B7280" }}>This product has no stock in any warehouse.</p>
            </div>
          )}
          {selectedStockRow && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              {/* LEFT PANEL */}
              <div
                style={{
                  flex: 1,
                  backgroundColor: "#F3F4F9",
                  borderRadius: "14px",
                  border: "1px solid #D9D9D9",
                  padding: "20px",
                }}
              >
                {/* TITLE ROW */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <div style={{ fontSize: "1em", fontWeight: 500, color: "#0F0718" }}>Request Stock Transfer for {selectedStockProduct?.name || "Product Name"}</div>

                  {/* Qty label here */}
                  <div style={{ fontSize: "13px", fontWeight: 500, color: "#000", paddingRight: "4px" }}>Qty</div>
                </div>

                {/* DROPDOWN + QTY ROW */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                    width: "100%",
                  }}
                >
                  {/* SELECT OUTLET */}
                  {selectedStockRow.outletName} — {selectedStockRow.batchNumber}
                  {/* QTY BOX */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "8px",
                      height: "30px",
                      width: "90px",
                      padding: "0 8px",
                      justifyContent: "space-between",
                    }}
                  >
                    <input
                      inputMode="numeric"
                      pattern="[0-9]*"
                      min="1"
                      style={{
                        border: "none",
                        outline: "none",
                        width: "40px",
                        fontSize: "0.95em",
                        textAlign: "center",
                      }}
                      value={requestQty}
                      onChange={(e) => {
                        const v = e.target.value;
                        const num = v.replace(/\D/g, "");
                        setRequestQty(num === "" ? "" : Number(num));
                      }}
                    />

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div style={{ cursor: "pointer", fontSize: "8px", userSelect: "none" }} onClick={() => setRequestQty((prev) => Number(prev || 0) + 1)}>
                        ▲
                      </div>
                      <div style={{ cursor: "pointer", fontSize: "8px", userSelect: "none" }} onClick={() => setRequestQty((prev) => Math.max(1, Number(prev) - 1))}>
                        ▼
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* REQUEST BUTTON */}
              <button
                onClick={handleStockTransferRequest}
                style={{
                  backgroundColor: "#f3f4f9",
                  color: "#0F0718",
                  border: "1px solid #d9d9d9",
                  padding: "12px 22px",
                  borderRadius: "8px",
                  fontSize: "0.9em",
                  fontWeight: "500",
                  height: "45px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Request Transfer
              </button>
            </div>
          )}
        </div>
      ) : (
        <p style={{ fontSize: "1em", color: "#6b7280", textAlign: "center", fontFamily: "Inter" }}>No product selected</p>
      )}
    </Drawer>
  );
};

export default React.memo(ProductPanelTable);
